import React from 'react';
import { Outlet } from 'react-router-dom';
import Card from 'components/Card';
import Steps from '../../../components/Steps';

import './style.scss';

const Email: React.FC = () => {
    return (
        <Card form>
            <h2>{__('邮箱修改')}</h2>
            <div className="modify-mail-root">
                <Steps type="modifyEmail" />
                <Outlet />
            </div>
        </Card>
    );
};

export default Email;
